module.exports = __webpack_public_path__ + "img/pauli-line-short.7406b27d.svg";